import { createAsyncThunk } from '@reduxjs/toolkit';
import { $api } from '../../../shared/api';
import { TasksData } from '../model/types/tasksInformationSchema';
import { tasksInformationActions } from '../model/slice/tasksInformation';
import { Task } from '../model/types/tasks';
import { getTasksInformation } from '../lib/getTasksInformation';

interface FetchTasksError {
    message: string;
}

export const fetchGanttTasks = createAsyncThunk<Task[], void, { rejectValue: FetchTasksError }>(
    'tasks/fetchGanttTasks',
    async (_, thunkApi) => {
        //@ts-ignore
        const url = routable.getRoute('getTasks');

        try {
            const response = await $api.get<TasksData>(`${url}?add_gantt=1`);

            const data = response.data;
            const { tasks, projects, tags, employees, ...tasksInformation } = data.data;

            const { projectsForFilter } = getTasksInformation(tasks, projects, tags, employees);

            thunkApi.dispatch(tasksInformationActions.changeNeedGantt());
            thunkApi.dispatch(
                tasksInformationActions.setGanttTasksInformation({
                    tabs: data.data.tabs,
                    projectsForFilter: projectsForFilter,
                })
            );
            thunkApi.dispatch(tasksInformationActions.setShowGanttTabs(true));
            return tasks;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
        }
    }
);
